import { colors } from '@ardoq/design-tokens';
import { BULK_POPOVER_ATTR, PlainTextPopover } from '@ardoq/popovers';
import { ComponentProps, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { DependencyMapHeaderLabel } from './DependencyMapHeaderLabel';

const REFERENCE_LABEL_TEXT_ATTR = 'data-reference-label-text';

export const resolveReferenceLabelPopover = (
  element: HTMLElement | SVGElement
): ReactNode | null => {
  const text = element.getAttribute(REFERENCE_LABEL_TEXT_ATTR);
  if (!text) {
    return null;
  }
  return <PlainTextPopover>{text}</PlainTextPopover>;
};

const DependencyMapReferenceLabelElement = styled(DependencyMapHeaderLabel)<{
  $textModerateColor?: string;
}>`
  color: ${({ $textModerateColor }) =>
    $textModerateColor ?? colors.textModerate};
  font-size: 11px;
  font-style: italic;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  word-break: break-all;
  margin: 4px 8px 0;
  ${({ $hasOnReferenceClick, $textModerateColor }) =>
    $hasOnReferenceClick &&
    css`
      display: inline-block;
      &:hover {
        color: ${$textModerateColor ?? colors.textModerate};
        text-decoration: underline;
      }
    `}
`;

type DependencyMapReferenceLabelProperties = {
  label: string;
};

const DependencyMapReferenceLabel = ({
  label,
  ...props
}: DependencyMapReferenceLabelProperties &
  ComponentProps<typeof DependencyMapReferenceLabelElement>) => (
  <DependencyMapReferenceLabelElement
    {...props}
    {...(label
      ? { [BULK_POPOVER_ATTR]: 'true', [REFERENCE_LABEL_TEXT_ATTR]: label }
      : {})}
  >
    {label}
  </DependencyMapReferenceLabelElement>
);

export { DependencyMapReferenceLabel };
